var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row center-xs" },
    _vm._l(_vm.social_tiles, function(tile, index) {
      return _c("div", { key: index, staticClass: "col-sm-4 pb15" }, [
        _c("div", { staticClass: "tile center-xs middle-xs" }, [
          _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: tile.image,
                expression: "tile.image"
              }
            ],
            staticClass: "tile-image",
            attrs: { alt: tile.alt }
          })
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }